/** eslint-disable @typescript-eslint/naming-convention -- thats the naming convetion in this case */
import {
  Academy,
  Box as BoxIcon,
  Chart,
  Clock,
  Dashboard,
  Favourite,
  Message,
  MyBenefits,
  Network,
  NewUser,
  Oriflame,
  Sales,
  Settings,
  Upgrade,
  WhatsNew,
} from '@ori-ui/icons';
import { Box, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

interface IconProps {
  icon: string | null;
}

const mapping = {
  'v-icon-dashboard-outlined': Dashboard,
  'v-icon-sales-outlined': Sales,
  'v-icon-whats-new': WhatsNew,
  'v-icon-wallet': BoxIcon,
  'v-icon-network-outlined': Network,
  'v-icon-academy': Academy,
  'v-icon-new-user-outlined': NewUser,
  'v-icon-favourite-outlined': Favourite,
  'v-icon-message-outlined': Message,
  'v-icon-settings-outlined': Settings,
  'v-icon-upgrade-outlined': Upgrade,
  'v-icon-clock-outlined': Clock,
  'v-icon-oriflame-symbol': Oriflame,
  'v-icon-chart': Chart,
  'v-icon-earnings': MyBenefits,
};

const Root = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(3),
  height: theme.spacing(6),
}));

export const Icon: FC<IconProps> = ({ icon }) => {
  const { getTestIdProps } = useTestId();
  if (icon === null) {
    return null;
  }

  const iconKey = icon.replace(/ [\w-]+/g, '');

  const MenuIcon = iconKey in mapping ? mapping[iconKey as keyof typeof mapping] : undefined;

  if (MenuIcon === undefined) {
    return null;
  }

  return (
    <Root>
      <MenuIcon
        sx={{ fontSize: '28px' }}
        {...getTestIdProps(`Icon-${iconKey}`)}
      />
    </Root>
  );
};
